import { useSelector } from "react-redux";
import { base_url } from "../../services/configServices/config";

const BookingSection = () => {
  const setting = useSelector((state) => state.meta?.setting);
  const image = useSelector((state) => state.meta?.image);

  return (
    <section
      className="section kf-cta kf-parallax"
      style={{ backgroundImage: `url(${base_url + image?.menuBanner})` }}
    >
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 align-center">
            <div className="kf-titles">
              <div
                className="kf-subtitle element-anim-1 scroll-animate"
                data-animate="active"
              >
                به یک میز در کافه نیاز دارید
              </div>
              <h3
                className="kf-title element-anim-1 scroll-animate"
                data-animate="active"
              >
                میز رزرو برای شما و اعضای خانواده
              </h3>
            </div>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 align-self-center align-center">
            <a
              href={`tel:${setting?.phoneNumber}`}
              className="kf-btn element-anim-1 scroll-animate"
              data-animate="active"
            >
              <span>تماس با مجموعه</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
